import editEntity from 'app/modules/entitiesOld/sagas/editEntity';
import retrieveEntity from 'app/modules/entitiesOld/sagas/retrieveEntity';
import retrieveEntityAlerts from 'app/modules/entitiesOld/sagas/retrieveEntityAlerts';

const sagaRegistry = [editEntity, retrieveEntity, retrieveEntityAlerts];

export default sagaRegistry;
